import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '@environment/environment';

import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FeatureFlagGuard implements CanActivate {
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const featurePath = route.data['featureFlag'] as string;

		if (!featurePath) return true;

		const value = featurePath.split('.').reduce((obj, key) => {
			return obj && obj[key] !== undefined ? obj[key] : undefined;
		}, environment.FEATURE_FLAGS as any);

		return value === true;
	}
}
